import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { select, Store } from '@ngrx/store';
import {
  AppState,
  FilterOption,
  RadiusFilterOption,
  RadiusFilterState,
} from '@immosky/types';
import {
  selectRadiusFilterState,
  setRadiusFilter,
} from '@immosky/object-search-filter';
import { ListButtonDirective } from '../../directives/list-button.directive';

@Component({
  selector: 'lib-radius-dropdown',
  templateUrl: './radius-dropdown.component.html',
  styleUrls: ['./radius-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadiusDropdownComponent {
  private radiusSubscription!: Subscription;

  isDropdownOpen = false;
  isActive = false;

  @Input()
  options: RadiusFilterOption[] = [];

  @Input()
  currentOption!: RadiusFilterOption;

  @ViewChildren(ListButtonDirective)
  buttons!: QueryList<ListButtonDirective>;

  constructor(
    private cdRef: ChangeDetectorRef,
    private store: Store<AppState>
  ) {
    this.radiusSubscription = this.store
      .pipe(select(selectRadiusFilterState))
      .subscribe((radiusFilter: RadiusFilterState) => {
        this.currentOption = radiusFilter.filter;
        this.isActive = radiusFilter.isActive;
        this.cdRef.markForCheck();
      });
  }

  toggleDropdown() {
    if (this.isDropdownOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isDropdownOpen = true;
    this.cdRef.markForCheck();
  }

  close() {
    window.requestAnimationFrame(() => {
      this.isDropdownOpen = false;
      this.cdRef.markForCheck();
    });
  }

  select(option: FilterOption) {
    this.store.dispatch(
      setRadiusFilter({
        filter: option as RadiusFilterOption,
      })
    );
    this.close();
  }
}
